import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { isMobileApp, StylesIndexInjections } from 'common-react';
import { zIndex } from '../theme/constants';

const mobileFooterBottomPadding = 16;
const getMobileFooterBottomPadding = (theme: Theme) => mobileFooterBottomPadding + theme.space.mobileBottomPadding();

export default makeUiStyles((theme: Theme) => createStyles({
  dialog: {
    '& .MuiDialog-paper': {
      minWidth: 504,
    },
  },
  drawer: {
    '& .MuiPaper-root': {
      marginBottom: 0,
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      borderBottomRightRadius: 0,
      borderBottomLeftRadius: 0,
      minWidth: 0,
    },
    '& $modalDialogContentWrapper': {
      padding: 0,
    },
  },
  headerContainer: {
    display: 'flex',
    gap: 10,
    alignItems: 'flex-start',
    paddingRight: 40,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingRight: 0,
    },
  },
  headerContainerSpinner: {
    alignItems: 'center',
  },
  icon: {
    width: 24,
    height: 24,
    flexShrink: 0,
    marginTop: 2,
  },
  spinnerIcon: {
    width: 'auto',
  },
  content: {
    marginTop: 24,
    '&$withoutHeader': {
      [theme.breakpoints.down('sm')]: {
        marginTop: 0,
      }
    }
  },
  buttonBox: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: 24,
    },
  },
  mobileContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: 'auto',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.color.greys[0],
    zIndex: zIndex.modalZIndex,
    paddingTop: isMobileApp() ? theme.space.mobileTopPadding() : undefined,

  },
  mobileTopBar: {
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '16px 16px 8px',
    borderBottom: `1px solid ${theme.color.greys[0]}`,
  },
  mobileTopBarWithBorder: {
    borderBottomColor: theme.color.greys[15],
  },
  mobileCloseButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 32,
    height: 32,
    padding: 0,
    background: 'none',
    border: `1px solid ${theme.color.greys[15]}`,
    borderRadius: '50%',
    cursor: 'pointer',
    color: theme.color.greys[75],
    '& svg': {
      width: 12,
      height: 12,
    },
  },
  mobileScrollable: {
    overflowY: 'auto',
    padding: '0 16px',
    scrollbarWidth: 'thin',
    scrollbarColor: `${theme.color.greys[80]} transparent`,
  },
  mobileFooter: {
    flexShrink: 0,
    padding: 16,
    paddingBottom: isMobileApp()
      ? getMobileFooterBottomPadding(theme)
      : mobileFooterBottomPadding,
    borderTop: `1px solid ${theme.color.greys[0]}`,
    marginTop: 'auto',
  },
  mobileFooterWithBorder: {
    borderTopColor: theme.color.greys[15],
  },
  mobileScrollableExpanded: {
    flex: 1,
  },
  modalDialogContentWrapper: {},
  withoutHeader: {},
}), { name: 'ModalDialog', index: StylesIndexInjections.OTHER });
